import { useState } from "react";
import { ChevronUp20Regular } from "@fluentui/react-icons";

import { useRootStore } from "store";

import "./ThreadSubscribers.scss";

export default function ThreadSubscribers() {
  const [showAllSubscribers, setShowAllSubscribers] = useState(false);

  const maxInitialSubscribers = 5;

  const { currentThread } = useRootStore((state) => state.inbox);
  const subscribers = currentThread?.subscribers || [];

  const getSubscribersToShow = () => {
    return subscribers.map((s, i) => (
      <span
        key={i}
        className={`text-nowrap mr-2 mb-1 subscriber-item ${
          !showAllSubscribers && i >= maxInitialSubscribers ? "collapsed" : ""
        }`}
      >
        {`${s.givenName} ${s.surName}`}
        {i !== subscribers.length - 1 && ", "}
      </span>
    ));
  };

  const toggleButtonContent = showAllSubscribers ? (
    <span className="d-flex align-items-center">
      <ChevronUp20Regular className="mr-1" /> Visa färre
    </span>
  ) : (
    `+ ${subscribers.length - maxInitialSubscribers} andra mottagare`
  );

  return (
    <div className="thread-subscribers mt-2">
      <div className="mr-2">Deltagare: </div>
      <div className="d-flex flex-wrap">
        {getSubscribersToShow()}

        <span
          className="text-nowrap subscribers-show-more"
          onClick={() => setShowAllSubscribers(!showAllSubscribers)}
        >
          {subscribers.length > maxInitialSubscribers && toggleButtonContent}
        </span>
      </div>
    </div>
  );
}
